import { Booking } from "src/business/booking";
import { toBookingHour } from "src/Utils/datetime";

export const mapBooking = (booking: Omit<Booking, "bookingHour">[]): Booking[] => {
    return booking.map((b) => ({
        ...b,
        bookingHour: toBookingHour(b.bookingDate),
        assignedTable: b.assignedTable ?? null,
        noShowCount: b.noShowCount ?? 0,
        hasNoShowWarning: b.hasNoShowWarning ?? false,
    }));
};
